/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 * */

/**
 * Back Icon
 *
 * @file BackIcon.jsx
 * @author Mohamed yasar arabath M
 * @since 0.0.1
 */

import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export default function BackIcon(props) {
  return (
    <SvgIcon {...props} viewBox="0 0 44 44">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.4174 20.9963H28C28.5523 20.9963 29 21.444 29 21.9963C29 22.5486 28.5523 22.9963 28 22.9963H18.4099L22.7034 27.292C23.0939 27.6827 23.0939 28.3162 22.7034 28.707C22.3128 29.0977 21.6797 29.0977 21.2892 28.707L15.2929 22.7075C14.9024 22.3168 14.9024 21.6832 15.2929 21.2925L21.2892 15.293C21.6797 14.9023 22.3128 14.9023 22.7034 15.293C23.0939 15.6838 23.0939 16.3173 22.7034 16.708L18.4174 20.9963Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
}
